export function formatTimeAgo(dateString) {
  if (!dateString) return '';

  const date = new Date(dateString);
  const now = new Date();
  const diffMs = Math.max(0, now - date);
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  const diffWeeks = Math.floor(diffDays / 7);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}D ago`;
  return `${Math.max(diffWeeks, 1)}W ago`;
}

export function groupNotificationsByPeriod(notifications = []) {
  const today = [];
  const lastWeek = [];
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfLastWeek = new Date(startOfToday);
  startOfLastWeek.setDate(startOfLastWeek.getDate() - 7);

  notifications.forEach((notification) => {
    const created = new Date(notification.created_at);
    if (created >= startOfToday) {
      today.push(notification);
    } else if (created >= startOfLastWeek) {
      lastWeek.push(notification);
    }
  });

  return { today, lastWeek };
}

export function getNotificationIconType(title = '', body = '') {
  const text = `${title} ${body}`.toLowerCase();

  if (text.includes('download')) return 'download';
  if (text.includes('offer') || text.includes('off') || text.includes('discount')) return 'offer';
  if (text.includes('progress') || text.includes('completed') || text.includes('lesson')) return 'progress';
  if (text.includes('report') || text.includes('performance')) return 'report';
  if (text.includes('chapter') || text.includes('course') || text.includes('upload')) return 'chapter';

  return 'default';
}
